import "./index.css";
import EllipseGenerator from "./EllipseGenerator";

export function App() {
  return <EllipseGenerator />;
}

export default App;
